import { React, useEffect, useState } from "react";
import secureLocalStorage from "react-secure-storage";

import { useNavigate } from "react-router-dom";

import logo from "../Images/logo.png";

import StorageService from "../services/storage.service";
import { Helmet } from "react-helmet";
export default function UserformSurvey() {
  const [ans1, setAns1] = useState(" ");
  const [ans2, setAns2] = useState(" ");
  const [show, setShow] = useState(false);

  const [errors, setErrors] = useState({});

  // const [signoutTime, setSignoutTime] = useState(180000);
  const [signoutTime, setSignoutTime] = useState(900000);

  const TITLE =
    process.env.REACT_APP_API_SITE_TITLE + " | Customer Survey Form";
  const navigate = useNavigate();

  // FIXME
  localStorage.setItem("returnpage", true);
  localStorage.setItem("page", "/survey-form");

  useEffect(() => {
    function timeout() {
      setTimeout(function () {
        StorageService.destroyTimeout();
        window.location.replace("/");
        return false;
      }, signoutTime);
    }

    timeout();
  }, [signoutTime]);
  const handleChangeans1 = (event) => {
    const ans1 = event.target.value;
    setAns1(ans1);
    localStorage.setItem("ans1", ans1);
  };
  const handleChangeans2 = (event) => {
    const ans2 = event.target.value;
    setAns2(ans2);
    localStorage.setItem("ans2", ans2);
  };

  const submituserRegistrationForm = (e) => {
    e.preventDefault();
    if (validate()) {
      localStorage.setItem("userformopen", "ture");
      // StorageService.setFormStatus(true);

      secureLocalStorage.setItem("Survey", {
        ans1: ans1,
        ans2: ans2,
      });
      navigate("/user-form", { replace: true });
    } else {
      localStorage.setItem("userformopen", false);
      // StorageService.setFormStatus(false);
    }
  };
  const validate = () => {
    let errors = {};
    let formIsValid = true;

    if (ans1 === " ") {
      formIsValid = false;
      errors["ans1"] = "Please select the option";
      setErrors(errors);
      return false;
    }

    if (ans2 === " ") {
      formIsValid = false;
      errors["ans2"] = "Please select the option";
      setErrors(errors);
      return false;
    }

    return formIsValid;
  };

  const Voucher = localStorage.getItem("voucher");
  const userform = localStorage.getItem("userform");

  useEffect(() => {
    if (userform === "true") {
      navigate("/user-form", { replace: true });
    }

    if (Voucher === undefined || Voucher == null) {
      localStorage.setItem("returnpage", false);
      localStorage.setItem("userform", false);
      localStorage.removeItem("page");
      localStorage.removeItem("ans1");
      localStorage.removeItem("ans2");
      localStorage.removeItem("ans3");
      localStorage.removeItem("ans4");
      localStorage.removeItem("ans5");
      window.location.replace("/");
    } else {
      setShow(true);
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <section className="form-body-center form-section-bg new-register">
        <div className="container">
          <div className="row gy-4 align-items-center">
            <div className="col-12 col-md-12 col-xl-12">
              <div className="register-logo">
                <img
                  src={logo}
                  alt="city-logo.png"
                  className="img-fluid"
                  width="360"
                  height="118"
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-xl-12">
              <div className="card border-0 rounded-4 p-0">
                <div className="card-body p-3 p-md-4 p-xl-5">
                  <form
                    onSubmit={submituserRegistrationForm}
                    name="userRegistrationForm"
                  >
                    <div className="row gy-3 overflow-hidden">
                      <div className="col-12 col-xl-12 mt-0 text-center">
                        <h2 className="form-heading">Online Customer Survey</h2>
                        <hr />
                      </div>

                      <div className="col-md-12  col-sm-12 mb-0 mt-0">
                        <fieldset
                          className={`checkbox-group yes-no-chk ${
                            errors.ans1 ? "danger-error" : ""
                          }`}
                        >
                          <legend className="checkbox-group-legend">
                            1. Would you refer us to a friend or neighbor?
                          </legend>

                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="radio"
                                name="imgname"
                                id="Yes"
                                value="YES"
                                onChange={handleChangeans1}
                                className="checkbox-input"
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-label">YES</span>
                              </span>
                            </label>
                          </div>

                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="radio"
                                name="imgname"
                                id="NO"
                                value="NO"
                                onChange={handleChangeans1}
                                className="checkbox-input"
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-label">NO</span>
                              </span>
                            </label>
                          </div>
                        </fieldset>

                        <div className="errorMsg">{errors.ans1}</div>
                      </div>

                      <div className="col-md-12  col-sm-12 mb-0">
                        <fieldset
                          className={`checkbox-group yes-no-chk ${
                            errors.ans2 ? "danger-error" : ""
                          }`}
                        >
                          <legend className="checkbox-group-legend">
                            2. Were you satisfied with our inspection/team?
                          </legend>

                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="radio"
                                name="imgname1"
                                id="Yes1"
                                value="YES"
                                onChange={handleChangeans2}
                                className="checkbox-input"
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-label">YES</span>
                              </span>
                            </label>
                          </div>

                          <div className="card-list">
                            <label className="checkbox-wrapper">
                              <input
                                type="radio"
                                name="imgname1"
                                id="NO1"
                                value="NO"
                                onChange={handleChangeans2}
                                className="checkbox-input"
                              />
                              <span className="checkbox-tile">
                                <span className="checkbox-label">NO</span>
                              </span>
                            </label>
                          </div>
                        </fieldset>

                        <div className="errorMsg">{errors.ans2}</div>
                      </div>

                      <div className="col-md-4 col-sm-12 ">
                        <div className="d-grid">
                          <button
                            className="btn btn-primary btn-lg"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className={`fix-white ${show ? "hide" : ""}`}></div>
    </>
  );
}
